import { SelecaoAcessorioPropostaValidador } from '@/features/simulador/brasil/domain/validators/selecao-acessorio-proposta-validador'
import type { SelecaoProdutoPropostaValidadorBase } from '@/features/simulador/brasil/domain/validators/selecao-produto-proposta-validador-base'
import { SelecaoUnidadePropostaValidador } from '@/features/simulador/brasil/domain/validators/selecao-unidade-proposta-validador'
import type { TGetSimulacoesRelacionadas } from '@/features/simulador/brasil/types/simulacao.type'

type TSelecaoProdutoPropostaFactory = {
  simulacoes: TGetSimulacoesRelacionadas['relacionadas']
  simulacaoSelecionada: TGetSimulacoesRelacionadas['relacionadas'][number]
  tipoProdutoSimulacaoDoSimulador: TGetSimulacoesRelacionadas['simulacaoPrincipal']['tipoDoProduto']
}

export class SelecaoProdutoPropostaFactory {
  static create({
    tipoProdutoSimulacaoDoSimulador,
    simulacoes,
    simulacaoSelecionada,
  }: TSelecaoProdutoPropostaFactory): SelecaoProdutoPropostaValidadorBase {
    switch (tipoProdutoSimulacaoDoSimulador) {
      case 'Unidade':
        return new SelecaoUnidadePropostaValidador({ simulacoes, simulacaoSelecionada })
      case 'Acessorio':
        return new SelecaoAcessorioPropostaValidador({ simulacoes, simulacaoSelecionada })
      default:
        throw new Error(`Tipo de produto desconhecido: ${tipoProdutoSimulacaoDoSimulador}`)
    }
  }
}
